import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

const baseCls = 'lt-gallery';
const progressCls = `${baseCls}-progress`;

class Gallery extends React.PureComponent {
  images = [];

  constructor(props) {
    super(props);

    this.state = {
      loaded: 0,
    };
  }

  componentDidMount() {
    if (this.total > 0) {
      this.loadImages();
    }
  }

  /**
   * Возвращает статус загрузки всех изображений
   * @returns {boolean}
   */
  get isLoaded() {
    const { loaded } = this.state;
    return loaded === this.total;
  }

  /**
   * Возвращает общее количество изображений
   * @returns {number}
   */
  get total() {
    const { data } = this.props;
    return Array.isArray(data) ? data.length : 0;
  }

  /**
   * Возвращает статус загрузки всех изображений в %
   * @returns {string}
   */
  get progress() {
    const { loaded } = this.state;
    return Math.round((loaded / this.total) * 100);
  }

  /**
   * Загружает изображения
   */
  loadImages() {
    const { data } = this.props;

    data.forEach((url) => {
      const img = document.createElement('img');

      img.addEventListener(
        'load',
        () => {
          this.setState((state) => ({
            loaded: state.loaded + 1,
          }));
        },
        { once: true },
      );

      img.src = url;

      this.images.push(img);
    });
  }

  renderProgress() {
    return (
      <div className={progressCls}>
        <div className={`${progressCls}__status`}>
          <div
            className={`${progressCls}__filler`}
            style={{ width: `${this.progress}%` }}
          />
        </div>
      </div>
    );
  }

  renderGallery() {
    const { alt, data } = this.props;

    if (!this.total) {
      return null;
    }

    return data.length > 1 ? (
      <Carousel
        className="lt-carousel"
        showArrows
        emulateTouch
        showStatus={false}
        showIndicators={false}
        showThumbs
      >
        {data.map((url) => (
          <img key={url} src={url} alt={alt} />
        ))}
      </Carousel>
    ) : (
      <img src={data[0]} alt={alt} />
    );
  }

  render() {
    const { className } = this.props;
    return (
      <div className={cn(baseCls, { [className]: !!className })}>
        {this.isLoaded ? this.renderGallery() : this.renderProgress()}
      </div>
    );
  }
}

Gallery.defaultProps = {
  alt: null,
  className: null,
  data: null,
};

Gallery.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.string.isRequired),
};

export default Gallery;
